import { render, staticRenderFns } from "./AddSuppliersModal.vue?vue&type=template&id=6f52fa2c&"
import script from "./AddSuppliersModal.vue?vue&type=script&lang=js&"
export * from "./AddSuppliersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports